import { mutation } from "../_generated/server";
import { v } from "convex/values";

export const updatePostGroup = mutation({
  args: {
    postId: v.id("posts"),
    groupId: v.union(v.id("groups"), v.null()),
  },
  handler: async (ctx, args) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated call to updatePostGroup");
    }

    const post = await ctx.db.get(args.postId);
    if (!post || post.userId !== identity.subject) {
      throw new Error("Post not found or unauthorized");
    }

    // If groupId is null, we're moving to ungrouped
    if (args.groupId !== null) {
      const group = await ctx.db.get(args.groupId);
      if (!group || group.userId !== identity.subject) {
        throw new Error("Group not found or unauthorized");
      }
    }

    await ctx.db.patch(args.postId, {
      groupId: args.groupId,
    });
  },
});

export const createGroup = mutation({
  args: {
    name: v.string(),
  },
  handler: async (ctx, args) => {
    const identity = await ctx.auth.getUserIdentity();
    if (!identity) {
      throw new Error("Unauthenticated call to createGroup");
    }

    const userId = identity.subject;
    
    // Get the highest order number
    const groups = await ctx.db
      .query("groups")
      .withIndex("by_userId", (q) => q.eq("userId", userId))
      .order("desc", "order")
      .take(1);
    
    const order = groups.length > 0 ? groups[0].order + 1 : 0;

    return await ctx.db.insert("groups", {
      userId,
      name: args.name,
      order,
      createdAt: Date.now(),
    });
  },
});